import React from 'react';
import { browserHistory, Link } from 'react-router';
import { Grid, Col, Row, Panel, ListGroup, ListGroupItem, Button } from 'react-bootstrap';
import Immutable from 'immutable';
import FieldComponent from './FieldComponent';
import { makeGrids } from '../../helpers/makeGrids';
import { getColSize } from '../../helpers/common';
import {t} from '../../helpers/translate.js'
import LoadingComponent from './LoadingComponent';
import * as access from '../../helpers/access'
import { request } from '../../helpers/request';

let config = require('config');

class ResultItemComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      loading: false,
    }
  }

  componentWillMount() {
    this.setState({
      data: Immutable.fromJS({ 'search': this.props.item })
    });
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      data: Immutable.fromJS({ 'search': newProps.item })
    });
  }

  togglePanel() {
    this.setState({
        open: !this.state.open
      }
    );
  }

  getResultsEmailBtn() {
    return (this.props.searchType === 'bulkuploadlist');
  }

  handleClick() {
    return browserHistory.push(this.getLink());
  }

  getPanelTitle(values) {
    const link_class = 'btn button-secondary button-minor pull-right';
    return (
      <div>
        <div>
        <Grid fluid>
          <Row className='header-flex' onClick={this.togglePanel.bind(this)}>
            {
              values.map((value, index) => (
                <Col key={`${value}-${index}`} sm={getColSize(this.props.params[index])} className='result-item-col'>
                  {value}
                </Col>
              ))
            }
              <Col sm={2} className='button-container'>
                {this.props.searchType === 'report' ? (
                  <div>
                    <Button
                      className={link_class}
                      onClick={() => this.props.resendReport(this.props.scope, this.props.item.report_id)}
                    >
                      {t('Re-send')}
                    </Button>
                  </div>
                ) :
                  !this.props.headers.every(_.isNull) && (
                    <div>
                      <Button
                        className="btn button-secondary button-minor view-button"
                        onClick={this.handleClick.bind(this)}
                      >
                        View
                      </Button>
                    </div>
                  )}
                {this.getResultsEmailBtn() && (
                  <div>
                    <Button
                      onClick={() =>
                        this.props.regenerateResultsEmail(
                          this.props.item.bulk_upload_id
                        )
                      }
                      className='btn button-secondary button-minor email-button'
                    >
                      {t('Send Results Email')}
                    </Button>
                  </div>
                )}
              </Col>
          </Row>
        </Grid>
        </div>
      </div>
    );
  }

  getLink(){
    switch(this.props.searchType){
      case 'applicant':
        var state = {applicationId: this.props.item.application_id}
        var pathname = `/manage/${this.props.item.application.source}`
        break;

      case 'user':
        var state = {userId: this.props.item.id}
        var pathname = `/user`
        break;

      case 'quote':
        var state = {applicationId: this.props.item.application_id}
        var pathname = `/quote/${this.props.item.application.source}`
        break;

      case 'claim':
        var state = {claim_id: this.props.item.id}
        var pathname = `/claim`
        break;

      case 'bulkuploadlist':
        var state = { listId: this.props.item.bulk_upload_id }
        var pathname = `/uploaddetails`
        break;

      case 'uploaddetails':
        var state = {applicationId: this.props.item.application_id}
        var pathname = `/manage/${this.props.item.source}`
        break;

      case 'report':
        var state = {reportId: this.props.item.report_id}
        var pathname = `/report/${this.props.item.report_id}`
        break;
    }

    const link = {
      state: state,
      pathname: pathname
    }

    return link;
  }

  checkCondition(condition) {
    if (condition.values) {
      return condition.values.includes(this.state.data.getIn(condition.key_path));
    } else if (!condition.function) {
      return this.state.data.getIn(condition.key_path) === condition.value
    }
  }

  hideIfSomeIsTrue(item) {
    return (item.do_not_show_if && item.do_not_show_if.some(this.checkCondition.bind(this)))
  }

  fill(fields) {
    const filteredFields = access.checkAccessLevel('viewonly') ? fields.filter(element => element.as !== 'Premium') : fields;
    const elems = filteredFields.map((field, k) => {
      if (!this.hideIfSomeIsTrue(field)) {
        return (
          <div>
            <label className='text-uppercase'>{field.as}</label>
            <div>
              <FieldComponent
                type={field.type}
                format={field.format}
                keyPath={field.key_path}
                options={field.options}
                args={field.args}
                isStatic={true}
                data={this.state.data}
              />
            </div>
          </div>
        );
      }
    });

    return makeGrids(3, elems);
  }

  failQueuedPolicy() {
    request(
      `${config.default.api}/bulkupload/failQueuedPolicy/${this.props.item.bulk_upload_id}`,
      'POST',
      null,
      function (response) {
        if (response.success) {
          window.location.reload()
        }
      }
    );
  }

  render() {
    return (
      <div>
        <Panel header={this.getPanelTitle(this.props.headers)} className='listing-header-container' collapsible expanded={this.state.open}>
          <ListGroup fill>
            {this.props.groups.map((group, i) => {
              if (group.group_name === 'Details') {
                return (
                  <ListGroupItem key={i}>
                    <div className='row'>
                      <div className='col-md-2'><label className='text-uppercase'>{group.group_name}</label></div>
                      <div className='col-md-8'>{this.fill(group.fields)}</div>
                      {access.isSuperAdmin('ingle') && this.props.item.queued > 0 && (
                        <div className='col-md-2'>
                          <Button
                            className='btn button-minor button-secondary pull-right btn-fail-queued-policy'
                            onClick={this.failQueuedPolicy.bind(this)}
                          >
                            {t('Fail Queued Policy')}
                          </Button>
                        </div>
                      )
                      }
                    </div>
                  </ListGroupItem>
                );
              }

              return null;
            })}
          </ListGroup>
        </Panel>
        <LoadingComponent show={this.state.loading} text={t('Sending')} />
      </div>
    );
  }
}

ResultItemComponent.displayName = 'ResultItemComponent';
export default ResultItemComponent;



// WEBPACK FOOTER //
// ./src/components/common/ResultItemComponent.js